export default {
  baseStyle: {
    root: {
      borderRadius: '25%',
    }
  },
};
